import { type Ref, ref, watch } from 'vue';

export function useDialogTriggerFocus(
  isOpen: Ref<boolean>,
  triggerEl: Ref<HTMLElement | null | undefined>,
) {
  const fallbackTrigger = ref<HTMLElement | null>(null);

  // flush:'pre' (default) fires before Vue re-renders, so document.activeElement is still the
  // trigger when captured here. flush:'post' would capture a reka-ui dialog element instead.
  watch(isOpen, (open) => {
    if (open && !triggerEl.value) {
      fallbackTrigger.value = document.activeElement as HTMLElement | null;
    }
  });

  function handleCloseAutoFocus(event: Event) {
    const target = triggerEl.value ?? fallbackTrigger.value;
    if (target && target.isConnected) {
      event.preventDefault();
      target.focus();
    }
  }

  return { handleCloseAutoFocus };
}
